(function () {
	'use strict';

	angular.module('dcApp').directive('selectCharttype', [
		'$parse',
		function ($parse) {
			var controller = [
				'$scope',
				function ($scope) {
					var vm = this;
					$scope.select = function (type, subType) {
						$scope.vm.data.action(type, subType);
					};
				},
			];

			return buildDirectiveReturnObject(
				{ data: '=' },
				controller,
				'./src/components/directives/handledata/selectChartType/selectChartType.html',
				function postLink(scope, element, attrs) {}
			);
		},
	]);
})();
